import React from "react";
import "./Header.css";
import logo from "../../assets/img/logo-color.png"
const Header: React.FC = () => {
  const handleBack = () => {
    window.history.back();
  };

  const handleLogoClick = () => {
    window.location.href = "/desired-path";
  };

  return (
    <header className="header">
      {/* Back Link */}
      <button className="button" onClick={handleBack}>
        <span className="arrow">&larr;</span> Back
      </button>

      {/* Logo */}
      <div className="navbarImg">
      <a href="https://38nguk.in/"><img loading="lazy"style={{ width: "85px",height:"65px" }}  src={logo} alt=""/></a>

      </div>

      {/* Placeholder for spacing */}
      <div style={{ width: "40px" }} />
    </header>
  );
};

export default Header;